import { apiClient } from "../lib/apiClient";
import type { Course } from "../types";

export interface CourseInput {
  name: string;
  description?: string | null;
  ageMin: number;
  ageMax: number;
  isActive?: boolean;
}

export async function listCourses(): Promise<Course[]> {
  const { data } = await apiClient.get<{ courses: Course[] }>("/courses");
  return data.courses;
}

export async function getCourse(id: string): Promise<Course> {
  const { data } = await apiClient.get<{ course: Course }>(`/courses/${id}`);
  return data.course;
}

export async function createCourse(input: CourseInput): Promise<Course> {
  const { data } = await apiClient.post<{ course: Course }>("/courses", input);
  return data.course;
}

export async function updateCourse(id: string, input: Partial<CourseInput>): Promise<Course> {
  const { data } = await apiClient.patch<{ course: Course }>(`/courses/${id}`, input);
  return data.course;
}

export async function deleteCourse(id: string): Promise<void> {
  await apiClient.delete(`/courses/${id}`);
}
